import { ProcessingOverlay } from '@components'

import { BorderRadius, Color, SectionMessage, Text } from '@billy/design-system'
import { Trans } from 'react-i18next'

import { useHasInvoices } from '@features/invoices/hooks/useHasInvoices'
import { useUserOrganization } from '@modules-deprecated/app/organization'

export const InvoicePrefixDescription = () => {
  const { organization } = useUserOrganization()
  const { hasInvoices, isLoading } = useHasInvoices()
  const isCountryFrance = organization?.countryId === 'FR'

  if (isLoading) {
    return <ProcessingOverlay borderRadius={BorderRadius.R12} color={Color.White} withAnimation />
  }

  return hasInvoices ? (
    <SectionMessage closable={false} showIcon variant="warning">
      {isCountryFrance ? (
        <Trans i18nKey="external_invoices.editor.invoice_prefix_and_number_modal.description.fr">
          Changing your invoice numbering can
          <Text as="span" weight="bold">
            expose you to legal penalties
          </Text>
          . It must be chronological and continuous. If in doubt, consult your accountant.
        </Trans>
      ) : (
        <Trans i18nKey="external_invoices.editor.invoice_prefix_and_number_modal.description">
          Changing your invoice numbering can expose you
          <Text as="span" weight="bold">
            in the event of a tax audit
          </Text>
          . It must be chronological and continuous. If in doubt, consult your accountant.
        </Trans>
      )}
    </SectionMessage>
  ) : (
    <SectionMessage closable={false} showIcon variant="info">
      <Trans i18nKey="external_invoices.editor.invoice_prefix_and_number_modal.first_invoice_description">
        <Text as="span" weight="bold">
          If it’s not your first invoice
        </Text>
        , enter the assigned numbering of your last invoice. Any rupture in the continuity can subject to legal
        constraints.
      </Trans>
    </SectionMessage>
  )
}
